"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VrfConsumerInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_hook_form_1 = require("react-hook-form");
const mui_inputs_entity_1 = require("@dzambalaorg/mui-inputs-entity");
const types_1 = require("@framework/types");
const VrfConsumerInput = props => {
    const { contractId } = props;
    const form = (0, react_hook_form_1.useFormContext)();
    const handleChange = (_event, option) => {
        form.setValue("contractId", option?.id ?? 0, { shouldDirty: true });
        form.setValue("address", option?.address ?? "0x");
    };
    return ((0, jsx_runtime_1.jsx)(mui_inputs_entity_1.EntityInput, { name: "contractId", controller: "contracts", onChange: handleChange, fetchData: { contractId, contractFeatures: [types_1.ContractFeatures.RANDOM, types_1.ContractFeatures.GENES] }, autoSelect: true }));
};
exports.VrfConsumerInput = VrfConsumerInput;
//# sourceMappingURL=index.js.map